// CAT Mock 6 — QA section.
const catMock6Qa = [
  {
    id: 47,
    type: "mcq",
    question: "A sum of money lent at simple interest amounts to ₹6,600 in 2 years and to ₹7,500 in 5 years. What is the rate of interest per annum?",
    options: [
      "A. 5%",
      "B. 6%",
      "C. 4%",
      "D. 7.5%"
    ],
    answer: "A"
  },
  {
    id: 48,
    type: "tita",
    question: "A is twice as efficient as B, and together they can finish a piece of work in 18 days. In how many days can A alone finish the work?",
    answer: "27"
  },
  {
    id: 49,
    type: "mcq",
    question: "How many positive divisors does 720 have?",
    options: [
      "A. 24",
      "B. 36",
      "C. 30",
      "D. 28"
    ],
    answer: "C"
  },
  {
    id: 50,
    type: "tita",
    question: "The present ages of A and B are in the ratio 5 : 7. Six years from now, the ratio of their ages will be 3 : 4. What is B's present age (in years)?",
    answer: "42"
  },
  {
    id: 51,
    type: "mcq",
    question: "The price of sugar rises by 25%. By what percentage must a household reduce its consumption of sugar so that its expenditure on sugar remains unchanged?",
    options: [
      "A. 25%",
      "B. 20%",
      "C. 18%",
      "D. 22.5%"
    ],
    answer: "B"
  },
  {
    id: 52,
    type: "tita",
    question: "What is the sum of all the three-digit numbers that can be formed using each of the digits 1, 2 and 3 exactly once?",
    answer: "1332"
  },
  {
    id: 53,
    type: "mcq",
    question: "If α and β are the roots of the equation x² − 7x + 10 = 0, what is the value of α³ + β³?",
    options: [
      "A. 143",
      "B. 123",
      "C. 153",
      "D. 133"
    ],
    answer: "D"
  },
  {
    id: 54,
    type: "tita",
    question: "What is the remainder when 3¹⁰² is divided by 11?",
    answer: "9"
  },
  {
    id: 55,
    type: "mcq",
    question: "A card is drawn at random from a well-shuffled pack of 52 playing cards. What is the probability that it is either a king or a heart?",
    options: [
      "A. 17/52",
      "B. 1/4",
      "C. 4/13",
      "D. 1/13"
    ],
    answer: "C"
  },
  {
    id: 56,
    type: "tita",
    question: "In how many ways can a committee of 3 men and 2 women be chosen from a group of 6 men and 5 women?",
    answer: "200"
  },
  {
    id: 57,
    type: "mcq",
    question: "The two shorter sides of a right-angled triangle are 9 cm and 12 cm. What is the length of the perpendicular drawn from the right angle to the hypotenuse?",
    options: [
      "A. 7.5 cm",
      "B. 6.8 cm",
      "C. 8 cm",
      "D. 7.2 cm"
    ],
    answer: "D"
  },
  {
    id: 58,
    type: "tita",
    question: "What is the smallest positive integer that leaves a remainder of 5 when divided by 6, 8 or 12, and is exactly divisible by 7?",
    answer: "77"
  },
  {
    id: 59,
    type: "mcq",
    question: "A boat whose speed in still water is 10 km/h goes 36 km downstream and returns to its starting point in a total of 7.5 hours. What is the speed of the stream?",
    options: [
      "A. 2 km/h",
      "B. 3 km/h",
      "C. 1.5 km/h",
      "D. 2.5 km/h"
    ],
    answer: "A"
  },
  {
    id: 60,
    type: "tita",
    question: "How many terms are there in the arithmetic progression 7, 11, 15, …, 199?",
    answer: "49"
  },
  {
    id: 61,
    type: "mcq",
    question: "The population of a town rises by 10% in the first year and by 20% in the second year, and then falls by 25% in the third year. What is the net change in the population over the three years?",
    options: [
      "A. 1% increase",
      "B. 1% decrease",
      "C. 5% increase",
      "D. No change"
    ],
    answer: "B"
  },
  {
    id: 62,
    type: "tita",
    question: "For real x, let f(x) = min(2x + 3, 15 − x). What is the maximum value of f(x)?",
    answer: "11"
  },
  {
    id: 63,
    type: "mcq",
    question: "Rice costing ₹40 per kg is mixed with rice costing ₹60 per kg so that the mixture is worth ₹52 per kg. In what ratio are the ₹40 rice and the ₹60 rice mixed?",
    options: [
      "A. 3 : 2",
      "B. 1 : 2",
      "C. 3 : 4",
      "D. 2 : 3"
    ],
    answer: "D"
  },
  {
    id: 64,
    type: "tita",
    question: "For how many integers n from 1 to 100 (both inclusive) is n² + n divisible by 6?",
    answer: "66"
  },
  {
    id: 65,
    type: "mcq",
    question: "Two trains, 150 m and 100 m long, run on parallel tracks in opposite directions at 54 km/h and 36 km/h respectively. How long do they take to cross each other completely?",
    options: [
      "A. 12 seconds",
      "B. 10 seconds",
      "C. 15 seconds",
      "D. 8 seconds"
    ],
    answer: "B"
  },
  {
    id: 66,
    type: "tita",
    question: "The length of a rectangle is increased by 20% and its breadth is decreased by 20%. By what percentage does its area decrease?",
    answer: "4"
  },
  {
    id: 67,
    type: "mcq",
    question: "How many positive integers less than 1000 are perfect squares or perfect cubes (or both)?",
    options: [
      "A. 37",
      "B. 40",
      "C. 38",
      "D. 34"
    ],
    answer: "A"
  },
  {
    id: 68,
    type: "tita",
    question: "In how many ways can five people stand in a row if two particular people among them must not stand next to each other?",
    answer: "72"
  }
];

export default catMock6Qa;
